import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../../../redux/projects/actions.projects';
import CommandsTestModeBubble from './CommandsTestModeBubble';
import VisualStateTestModeBubble from './VisualStateTestModeBubble';
import RequestTestModeBubble from './RequestTestModeBubble';
import ChatBubble from '../../ChatBubble/ChatBubble';
import ExpectedResponsesTestModeBubble from './ExpectedResponsesTestModeBubble';
import { ChatMessageType } from '../../../../../const/chatMessageType';

class TestModeBubble extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.expectedResponsesTestModeBubbleEl = React.createRef();
        this.requestTestModeBubbleEl = React.createRef();
    }

    render() {
        const {
            data,
            type,
            node,
            showExpectedResponses,
            conversationId,
            commandsInTestModeAreShownGlobally,
            project
        } = this.props;

        let bubbleHtml = JSON.stringify(data);

        if (type === 'request') {
            if (data?.visualState) {
                bubbleHtml = <VisualStateTestModeBubble
                    data={data}
                    node={node} />;
            } else {
                bubbleHtml = <RequestTestModeBubble
                    ref={this.requestTestModeBubbleEl}
                    data={data}
                    showExpectedResponses={showExpectedResponses}
                    node={node} />;
            }
        }
        if (type === 'response') {
            if (data?.commands) {
                if (commandsInTestModeAreShownGlobally) {
                    bubbleHtml = <CommandsTestModeBubble data={data} />;
                } else {
                    bubbleHtml = <React.Fragment />;
                }
            } else {
                bubbleHtml = <ChatBubble
                    isTestMode={true}
                    message={{ ...data, type: ChatMessageType.Text, ts: data.ts0 }}
                    project={project}
                />;
            }
        }

        if (type === 'expected-response') {
            if (node.visualProperties?.expectedResponses !== undefined) {
                bubbleHtml = <ExpectedResponsesTestModeBubble
                    ref={this.expectedResponsesTestModeBubbleEl}
                    node={node}
                    showExpectedResponses={showExpectedResponses}
                    conversationId={conversationId}
                />;
            } else {
                bubbleHtml = <React.Fragment />;
            }
        }

        return <div className={`test-mode-bubble`}>
            {bubbleHtml}
        </div>;
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        codeLinksAreShownGlobally: testMode.codeLinksAreShownGlobally,
        commandsInTestModeAreShownGlobally: testMode.commandsInTestModeAreShownGlobally,
        project: projectsInfo.currentProject,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(TestModeBubble);

